import React, { lazy } from 'react';
import { Route, Navigate } from 'react-router-dom';

const PRMDashboard = lazy(() => import('../components/prm/PRMDashboard'));
const PublisherPortfolio = lazy(() => import('../components/prm/publishers/PublisherPortfolio'));
const PublisherProfile = lazy(() => import('../components/prm/publishers/PublisherProfile'));
const PRMEvents = lazy(() => import('../components/prm/events/PRMEvents'));
const PRMEventDetail = lazy(() => import('../components/prm/events/EventDetail'));
const PRMMeetingPrep = lazy(() => import('../components/prm/publishers/MeetingPrep'));
const PRMEmailReview = lazy(() => import('../components/prm/email/PRMEmailReview'));
const EmailAccounts = lazy(() => import('../components/prm/email/EmailAccounts'));
const PRMContacts = lazy(() => import('../components/prm/contacts/PRMContacts'));
const ContactDetail = lazy(() => import('../components/prm/contacts/ContactDetail'));
const ReprintNoticesPage = lazy(() => import('../components/prm/reprint-notices/ReprintNoticesPage'));

export const prmRoutes = (
  <>
    <Route path="/publishers" element={<Navigate to="/prm/dashboard" replace />} />
    <Route path="/prm/dashboard" element={<PRMDashboard />} />
    <Route path="/prm/publishers" element={<PublisherPortfolio />} />
    <Route path="/prm/publishers/:id" element={<PublisherProfile />} />
    <Route path="/prm/publishers/:id/meeting-prep" element={<PRMMeetingPrep />} />
    <Route path="/prm/distributors" element={<PublisherPortfolio lockedType="distributor" />} />
    <Route path="/prm/distributors/:id" element={<PublisherProfile />} />
    <Route path="/prm/events" element={<PRMEvents />} />
    <Route path="/prm/events/:id" element={<PRMEventDetail />} />
    <Route path="/prm/email-review" element={<PRMEmailReview />} />
    <Route path="/prm/email-accounts" element={<EmailAccounts />} />
    <Route path="/prm/contacts" element={<PRMContacts />} />
    <Route path="/prm/contacts/:id" element={<ContactDetail />} />
    <Route path="/prm/reprints" element={<ReprintNoticesPage />} />
  </>
);
